import { useQuery } from "@tanstack/react-query";

import { api } from "./client";

export interface MeUser {
  id: string;
  email: string;
  name: string;
  picture_url: string | null;
}

export interface MeGroup {
  id: string;
  slug: string;
  name: string;
}

export interface MeResponse {
  user: MeUser;
  groups: MeGroup[];
  app_roles: Record<string, string[]>;
}

export const meApi = {
  get: () => api.get<MeResponse>("/api/me").then((r) => r.data),
  logout: () =>
    api
      .post<{ entra_logout_url: string }>("/api/auth/logout")
      .then((r) => r.data),
};

/** Hook used by AppShell to gate authenticated pages. */
export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: meApi.get,
    retry: 1,
  });
}

/** Is the current user an admin on audra-id itself? */
export function useIsAudraIdAdmin() {
  const { data } = useMe();
  return (data?.app_roles?.["audra-id"] ?? []).includes("admin");
}
